import { Map01 } from '@untitledui/icons';
import type { RefObject } from 'react';
import { IconButton } from '../../components/buttons/IconButton';
import { useFocusMap } from '../../hooks/useFocusMap';
import { en } from '../../locales/en';
import { useFollowedVehicleStore } from '../../store/useFollowedVehicleStore';
import type { MapRef } from 'react-map-gl/mapbox';

interface OverviewButtonProps {
  mapRef: RefObject<MapRef | null>;
}

function OverviewButton({ mapRef }: OverviewButtonProps) {
  const focusMap = useFocusMap(mapRef);
  const disableAutoFollow = useFollowedVehicleStore((state) => state.disableAutoFollow);

  const onOverviewClicked = () => {
    disableAutoFollow();
    focusMap();
  };

  return <IconButton icon={Map01} padding='8px' onClick={onOverviewClicked} title={en.overviewButton.title} />;
}

export default OverviewButton;
